import { useAtomValue } from "jotai";
import { Suspense } from "react";
import {
  DefaultNodeData,
  isTemplateTableId,
  showTableRecordUsageAtom,
} from "@zapier/canvas-state";
import { TableUsage } from "./TableUsage";

interface StepUsageProps {
  tableId: DefaultNodeData["tableId"];
  chatbotId: DefaultNodeData["chatbotId"];
}

export function StepUsage({ tableId }: StepUsageProps) {
  const showTableRecordUsage = useAtomValue(showTableRecordUsageAtom);

  function getComponent() {
    if (tableId && !isTemplateTableId(tableId) && showTableRecordUsage) {
      return <TableUsage tableId={tableId} />;
    }

    return null;
  }

  return <Suspense fallback={null}>{getComponent()}</Suspense>;
}
